module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "context": "Booking"
    }
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleGenericError),
      callback: function($$v) {
        _vm.showHandleGenericError = $$v
      },
      expression: "showHandleGenericError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        _vm.backToMovie()
      }
    }
  }, [_vm._v("Start again")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.order.Session) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-progress-steps', {
    attrs: {
      "num-steps": 4,
      "current-step": _vm.step,
      "step-names": _vm.stepNames,
      "step-type": _vm.stepType
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    staticClass: "text-right",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-countdown', {
    attrs: {
      "timer": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.order.Session) ? [(_vm.step == '3') ? [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('router-view')], 1)], 1)] : [_c('transition', {
    attrs: {
      "name": "sk-slide-x-transition"
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg9": ""
    }
  }, [_c('router-view')], 1)], 1)]] : _vm._e(), _vm._v(" "), (_vm.order && _vm.order.Tickets && _vm.step != 3 && _vm.order.Session) ? _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  }, [_c('sk-ticket', {
    attrs: {
      "order": _vm.order,
      "cinema": _vm.cinema
    }
  })], 1) : _vm._e()], 2)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e68aeb6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/booking/booking.vue
// module id = 544
// module chunks = 0